import { string } from "yup";

export const nonEmptyString = (label: string) =>
  string()
    .required(`${label} is required`)
    .test(
      "not-empty",
      `${label} cannot be empty`,
      (field) => !field || field.trim().length > 0
    )
    .test(
      "first-space",
      `${label} cannot start with space`,
      (field) => field?.charAt(0) !== " "
    )
    .test(
      "last-space",
      `${label} cannot end with space`,
      (field) => field?.charAt(field.length - 1) !== " "
    );
